"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8230,3117],{

/***/ 48230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Iframe_PopUpIframe; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./components/atoms/pop-up-base/index.ts + 1 modules
var pop_up_base = __webpack_require__(53117);
;// CONCATENATED MODULE: ./components/atoms/multimedia/Iframe/PopUpIframe/PopUpIframe.tsx





/**
 * PopUpIframe
 */ var PopUpIframe = function(_param) {
    var state = _param.state, src = _param.src, setState = _param.setState, className = _param.className, _title = _param.title, title = _title === void 0 ? "" : _title, _desc = _param.desc, desc = _desc === void 0 ? "" : _desc, props = (0,_object_without_properties/* default */.Z)(_param, [
        "state",
        "src",
        "setState",
        "className",
        "title",
        "desc"
    ]);
    var clickHanlder = function() {
        setState(!state);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pop_up_base["default"], {
        title: title,
        desc: desc,
        state: state,
        funcionOnClose: clickHanlder,
        className: "bg-white ".concat(className),
        type: "iframe",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            allowFullScreen: true,
            src: src,
            title: "Iframe Be Casa"
        }, props), {
            className: "absolute inset-0 h-full w-full border-none ".concat(className)
        }))
    });
};
PopUpIframe.displayName = "PopUpIframe";

;// CONCATENATED MODULE: ./components/atoms/multimedia/Iframe/PopUpIframe/index.ts

/* harmony default export */ var Iframe_PopUpIframe = (PopUpIframe);


/***/ }),

/***/ 53117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pop_up_base; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 23 modules
var dialog = __webpack_require__(65518);
// EXTERNAL MODULE: ./public/assets/icons/ExitPopUp.svg
var ExitPopUp = __webpack_require__(61740);
;// CONCATENATED MODULE: ./components/atoms/pop-up-base/PopUpBase.tsx



/**
 * PopUpBase
 */ var PopUpBase = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, state = param.state, children = param.children, funcionOnClose = param.funcionOnClose, thumbsChildren = param.thumbsChildren, desc = param.desc, title = param.title, _type = param.type, type = _type === void 0 ? "base" : _type, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "#fff" : _bgColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
        open: state,
        onClose: funcionOnClose,
        className: "fixed inset-0 z-50 grid place-items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Overlay */.V.Overlay, {
                className: "fixed inset-0 bg-[rgba(21,33,39,0.7)]",
                onClick: funcionOnClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Panel */.V.Panel, {
                className: "z-50 flex flex-col items-center overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex h-full flex-col items-center justify-around gap-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                backgroundColor: "".concat(bgColor, " !important")
                            },
                            className: "flex flex-col rounded-md text-primary-400 sm:justify-around ".concat(type === "galery" ? "bg-transparent sm:bg-white" : "", " h-fit w-full max-w-[calc(100vw-2rem)] p-4 sm:h-auto sm:w-auto sm:p-5 ").concat(className),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-2 flex flex-row justify-between gap-4 sm:mb-2 sm:mt-0 ".concat(type === "galery" ? "my-5" : "my-2"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col gap-1",
                                            children: [
                                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-heading text-heading--h3",
                                                    children: title
                                                }),
                                                desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-body text-body--secondary--bold",
                                                    children: desc
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopUp["default"], {
                                            heigth: 32,
                                            width: 32,
                                            className: "flex-shrink-0 hover:cursor-pointer",
                                            onClick: funcionOnClose
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: type === "galery" ? "min-h-[60vh] min-w-[80vw]" : type === "iframe" ? desc ? "relative h-[calc(100vh-68px)] min-w-[100vw] sm:h-[60vh] sm:min-w-[80vw]" : "relative h-[calc(100vh-48px)] min-w-[100vw] sm:h-[60vh] sm:min-w-[80vw]" : "h-[60vh] overflow-y-auto sm:h-auto sm:w-auto",
                                    children: children
                                })
                            ]
                        }),
                        thumbsChildren && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-3 min-h-fit sm:mb-0",
                            children: thumbsChildren
                        })
                    ]
                })
            })
        ]
    });
};
PopUpBase.displayName = "PopUpBase";

;// CONCATENATED MODULE: ./components/atoms/pop-up-base/index.ts

/* harmony default export */ var pop_up_base = (PopUpBase);


/***/ })

}]);